export type CookieKey = string;
export type CookieValue = string;

export class CookieUtil
{
    public static setTempCookie(domain:string, key:CookieKey, value:CookieValue):void
    {
        const cookieDate = new Date();
        cookieDate.setFullYear(cookieDate.getFullYear() + 1);

        value = global.escape(value);

        document.cookie = `${key}=${value};expires=${cookieDate};domain=${domain};path=/`;
    }

    public static clearCookie(domain:string, key:CookieKey):void
    {
        const cookieDate = new Date();
        cookieDate.setSeconds(cookieDate.getSeconds() - 30);
        const value = '';

        document.cookie = `${key}=${value};expires=${cookieDate};domain=${domain};path=/`;
    }

    public static getCookie(key:CookieKey):CookieValue | null
    {
        let result;

        return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie))
            ? (global.unescape(result[1])) : null;
    }
}
